import { Box } from '@mui/material';
import { useState } from 'react';

import { AISuggestionReviewProcessingBanner } from '@/modules/aiSuggestionReviewCard/components/AISuggestionReviewProcessingBanner';
import { useIsHouseholdWorkflowTrackerInProgress } from '@/modules/workflowTrackers/hooks/useIsHouseholdWorkflowTrackerInProgress';
import { WorkflowTrackerKind } from '@/types/schema';

/** Shows while uploaded documents are being extracted. */
export function DocumentsProcessingCallout() {
  const [isDismissed, setIsDismissed] = useState(false);
  const isExtractionProcessing = useIsHouseholdWorkflowTrackerInProgress(
    WorkflowTrackerKind.DocumentExtraction
  );

  if (isDismissed || !isExtractionProcessing) {
    return null;
  }

  return (
    <Box mb={2}>
      <AISuggestionReviewProcessingBanner
        suggestionTypeText="data"
        showReviewMessage={false}
        onDismiss={() => setIsDismissed(true)}
      />
    </Box>
  );
}
